import React from 'react';
import Breadcrumb from './Breadcrumb';

interface BreadcrumbItem {
  label: string;
  href?: string;
  current?: boolean;
}

interface ShowPageLayoutProps {
  breadcrumbItems: BreadcrumbItem[];
  children: React.ReactNode;
}

const ShowPageLayout: React.FC<ShowPageLayoutProps> = ({
  breadcrumbItems,
  children,
}) => {
  return (
    <div className="min-h-screen bg-base-100">
      <Breadcrumb items={breadcrumbItems} />
      {children}
    </div>
  );
};

export default ShowPageLayout;
